import * as coreEntities from 'core/store/index';
import { parseLearningObjectives } from 'core/utils/parses';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useLearningObjectives = ({ selectedObjectives }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [learningObjectives, setLearningObjectives] = useState([]);

  const listOfAllLearningObjectives = useSelector((state) => coreEntities.learningObjectives.selectors.getLearningObjectives(state));

  useEffect(() => {
    if (listOfAllLearningObjectives.length === 0) {
      dispatch(coreEntities.learningObjectives.actions.getLearningObjectives());
    }
  }, [dispatch]);

  useEffect(() => {
    if (selectedObjectives.length && listOfAllLearningObjectives.length) {
      const loGuids = selectedObjectives.map((lo) => lo.guid || lo);
      const tempSelectedLearningObjectives = parseLearningObjectives(listOfAllLearningObjectives.filter((item) => loGuids.includes(item.guid)));
      setLearningObjectives(tempSelectedLearningObjectives);
    }
  }, [listOfAllLearningObjectives, selectedObjectives]);

  useEffect(() => {
    if (listOfAllLearningObjectives.length > 0) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [listOfAllLearningObjectives]);

  return { isLoading, learningObjectives, listOfAllLearningObjectives };
};

export default useLearningObjectives;
